import { Recurrence } from '@tableau/self-service-schedules';

import { ScheduleDetails } from './ScheduleDetails';

export type scheduledActionEnum = 'Subscription' | 'Extract';
export type scheduledTypeEnum = 'Hourly' | 'Daily' | 'Weekly' | 'Monthly';

export interface SelfServiceSchedule {
  scheduledAction: scheduledActionEnum; // Extract/Subscription
  scheduleType: scheduledTypeEnum;  // Hourly/Daily/Weekly/etc...
  scheduleDetails: ScheduleDetails; // The recurrence info for a schedule
}

export namespace SelfServiceSchedule {
  export function fromRecurrence(recurrence: Recurrence, type: scheduledActionEnum): SelfServiceSchedule {
    return {
      scheduledAction: type,
      scheduleType: recurrence.recurrenceType as scheduledTypeEnum,
      scheduleDetails: recurrence.recurrenceDetails as ScheduleDetails,
    };
  }
}